import Vue from 'vue';
import axios from 'axios';
class Config {
    constructor ({ caller, rootState, dispatch }) {
        this.caller = caller;
        this.rootState = rootState;
        this.dispatch = dispatch;
    }

    productSpec (context) {
        return `?spec=["${context}*product:*:data","${context}*product:id","${context}*product:type","${context}*product:*:code:*"]`;
    }
    priceSpec (context) {
        return `?spec=["${context}*price:*", "${context}*basket:config","${context}*promotion:*"]`;
    }
    products (context) {
        return this.caller.get(`${this.rootState.config.productServicePort}/config${this.productSpec(context)}`);
    }

    prices (context) {
        return this.caller.get(`${this.rootState.config.priceServicePort}/config${this.priceSpec(context)}`);
    }

    async productsSaved ({ setupid }) {
        let envs, store, setup;
        envs = await this.dispatch('GetEnvConfigData', {context:setupid, role: 'admin' })
        store = await this.dispatch('GetShopById', setupid)
        setup = await this.dispatch('GetSetupDataById', setupid)

        return Vue.axios.post('/configurator/refresh', { setupid, envs, store, setup });
        //return Vue.axios.get(`/configurator/sync/${setupid}`, { setupid });

        //return axios.post('http://localhost:1337/refresh', { setupid });
    }
}

export default Config;
